<template>
  <div class="combine-container simple-search-table-container default-table">
    <div class="head">
      <div>
        <el-input v-model="queryParams.name" placeholder="模糊查询品牌集团名称" size="mini"/>
        <el-button type="primary" size="mini" @click="handelSearch">查询</el-button>
      </div>
      <div>
        <el-button v-if="userAuth.can_add_combine_brand" type="primary" size="mini" @click="handelCreate">新增品牌集团
        </el-button>
      </div>
    </div>

    <el-table :data="tableData" :span-method="objectSpanMethod" border height="calc(100% - 48px)">
      <el-table-column prop="no" label="序号" header-align="center" align="center" min-width="80"/>
      <el-table-column prop="name" label="品牌集团" header-align="center" align="center" min-width="160"
                       :show-overflow-tooltip="true"/>
      <el-table-column prop="tag_custom" label="分类标签" header-align="center" align="center" min-width="120"
                       :show-overflow-tooltip="true"/>
      <el-table-column prop="brands" label="品牌" min-width="160"
                       :show-overflow-tooltip="true"/>
      <el-table-column label="操作" header-align="center" align="center" min-width="120">
        <template slot-scope="{row}">
          <el-button v-if="userAuth.can_update_combine_brand" type="text" size="mini" icon="el-icon-edit"
                     @click="handelUpdate(row)">修改
          </el-button>
          <el-button v-if="userAuth.can_delete_combine_brand&&!row.brands" type="text" size="mini" icon="el-icon-delete"
                     @click="handelDelete(row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="formStore.type==='CREATE'?'新增品牌集团':'编辑品牌集团'" :visible.sync="dialogStore"
               width="580px"
               center>
      <el-input v-model="formStore.name" placeholder="请输入品牌集团名称" maxlength="50" show-word-limit/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStore = false">取 消</el-button>
        <el-button type="primary" @click="handelStoreSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {combineBrandDelete, combineBrandMap, combineBrandStore} from "@/api/combine";

const ModelFormStore = {
  type: 'CREATE',
  name: null,
  id: null,
}
const ConfigPage = {
  is_show: true,
  layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 10,
  page: 1,
}
export default {
  name: "index",
  data() {
    return {
      configPage: ConfigPage,
      loading: false,
      dialogStore: false,
      applyYearFrameDialog: false,
      applyYearFrameTheCustomer: false,
      formStore: {...{}, ...ModelFormStore},
      queryParams: {name: null},
      mapCombineIdCount: {},
      tableData: []
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    handelCreate() {
      this.formStore = {...{}, ...ModelFormStore}
      this.dialogStore = true;
    },
    handelUpdate(obj) {
      this.formStore = {
        type: 'UPDATE',
        name: obj.name,
        id: obj.id,
      }
      this.dialogStore = true;
    },
    handelDelete(obj) {
      this.showModal({
        h: this,
        text: `确认删除【${obj.name}】吗？`,
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          const response = await combineBrandDelete({id: obj.id})
          if (!response.success) {
            this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
            return;
          }
          this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
          await this.getTableData()
        }
      });
    },
    async handelStoreSure() {
      if (!this.formStore.name) {
        this.showToast({h: this, icon: "el-icon-error", text: '请填写品牌集团名称', duration: 2000});
        return false;
      }
      const response = await combineBrandStore(this.formStore)
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      await this.getTableData()
      this.dialogStore = false;
    },
    handelSearch() {
      this.getTableData(true)
    },
    getParams() {
      return this.queryParams
    },
    async getTableData(isSearch = false) {
      const response = await combineBrandMap(this.getParams(isSearch))
      const data = response.model || []
      let mapCombineIdCount = {}
      let no = 1;
      data.map((datum) => {
        datum.first_row = false;
        if (mapCombineIdCount[datum.id] === undefined) {
          mapCombineIdCount[datum.id] = 1
          datum.first_row = true;
          datum.no = no++;
        } else {
          mapCombineIdCount[datum.id]++;
        }
      })
      this.mapCombineIdCount = mapCombineIdCount;
      this.tableData = data
    },
    objectSpanMethod({row, columnIndex}) {
      if (columnIndex === 1 || columnIndex === 0) {
        if (row.first_row) {
          return {
            rowspan: this.mapCombineIdCount[row.id],
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    goYearFrame() {
      this.$router.push({path: '/project/customerYearFrame', query: {hand: 'proposer'}})
    }
  }
}
</script>

<style lang="scss">
.combine-container {
  padding: 24px;

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .el-input {
      width: 250px;
      margin-right: 12px;
    }
  }

  .el-table {
    margin-bottom: 10px;
  }
}
</style>
